import React from 'react';
import { translate } from '@utils/i18n';
import { FlagItem } from './FlagItem';
const NS = 'features.iim_review.tech_performance_drawer';
export function FeaturedRuleTrendFlagItem({ featuredRuleFinding, featuredRuleFindingTrend }) {
    return (React.createElement(FlagItem, { icon: "fa-list-check", title: translate('featured_rule_trend_title', {
            namespace: NS,
            affectedCount: featuredRuleFindingTrend.affected_inspections_count,
            windowCount: featuredRuleFindingTrend.window_count,
            defaultValue: '%{affectedCount} of the last %{windowCount} inspections flagged by your rule'
        }), description: featuredRuleFinding.directive_human }));
}
